import angular from 'angular';
import addInventoryItemTemplate from './addInventoryItem.template.html';

export default angular
  .module('books.ui.addInventoryItem', [])
  .service('AddInventoryItem', addInventoryItemService).name;
  
  /*****************************************************************************
   * Service: AddInventoryItem
   *
   * Service to display a dialog for adding inventory items. The show method
   * should be passed an array of products from the BooksSvc.getProductList
   * service call.
   *****************************************************************************/
/* @ngInject */
function addInventoryItemService($uibModal) {
  /** Dialog Controller. */
  function AddInventoryItemController(
    $scope,
    $filter,
    $uibModalInstance,
    uiGridConstants,
    Tools,
    InventoryOptionsColumn,
    BooksSvc,
    BusyScreen,
    DGProductPurchase,
    products
  ) {
    /** Current Category ID. */ var mCategoryID;
    /** Current Product. */ var mProduct;

    /* Build the category list from the provided products. */
    $scope.categoryList = Tools.mapUniqueObjects(products, 'categoryID', [
      { categoryID: 'id' },
      { category: 'name' }
    ]).sort(function (category1, category2) {
      return category1.name
        .toLowerCase()
        .localeCompare(category2.name.toLowerCase());
    });
    $scope.categoryList.unshift({ id: 0, name: 'All Categories' });

    /*-------------------------------*/
    /* Inventory Options Grid Config */
    /*-------------------------------*/
    var mInventoryColumn = new InventoryOptionsColumn();

    $scope.optsGrid = {
      enableColumnMenus: false,
      enableCellEditOnFocus: true,
      enableColumnMenus: false,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
      enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      columnDefs: [
        mInventoryColumn,
        {
          field: 'cost',
          maxWidth: 80,
          enableCellEdit: true,
          cellFilter: 'currency'
        },
        {
          field: 'qty',
          maxWidth: 80,
          enableCellEdit: true,
          cellFilter: 'number'
        },
        {
          field: 'total',
          maxWidth: 80,
          enableCellEdit: false,
          cellFilter: 'currency'
        }
      ]
    };

    /*---------------------------------------------------------*/
    /* Category ID Accessor. Filter the product list on change */
    /*---------------------------------------------------------*/
    $scope.categoryID = function (val) {
      if (arguments.length == 0) return mCategoryID;

      mCategoryID = val;

      /*---------------------------------*/
      /* Filter products for category ID */
      /*---------------------------------*/
      $scope.productList = [{ id: 0, name: 'Select a Product' }].concat(
        products.filter(function (p) {
          return !mCategoryID || p.categoryID == mCategoryID;
        })
      );

      /*----------------------*/
      /* Reset the product ID */
      /*----------------------*/
      $scope.product($scope.productList[0]);
    };

    /*---------------------------------------------------------------*/
    /* Product Accessor. On change, check for inventory products. */
    /*---------------------------------------------------------------*/
    $scope.product = function (product) {
      if (arguments.length == 0) return mProduct;

      mProduct = product;

      /*-----------------------------*/
      /* Clear previous entry values */
      /*-----------------------------*/
      $scope.optsGrid.data = [];
      $scope.invItem = null;

      if (!mProduct || !mProduct.id) return;

      BusyScreen.setBusy(true);
      BooksSvc.getInventoryProducts(mProduct.id).then(function (resp) {
        /*-----------------------*/
        /* Find the base product */
        /*-----------------------*/
        var baseProduct = resp.data
          .filter(function (p) {
            return p.options.length == 0;
          })
          .shift();

        /*-------------------------------*/
        /* Remove the base from the list */
        /*-------------------------------*/
        resp.data.splice(resp.data.indexOf(baseProduct), 1);

        /*-------------------------------------------*/
        /* Set remaining inventory combinations if   */
        /* any utilizing the DGProductPurchase class */
        /*-------------------------------------------*/
        $scope.optsGrid.data = resp.data.map(function (ip) {
          return new DGProductPurchase(ip, true, mProduct);
        });

        /*----------------------------------------------------------*/
        /* There are multiple inventory options, compile the master */
        /* option information from all the InventoryProductOption   */
        /* items to update the inventory column                     */
        /*----------------------------------------------------------*/
        if ($scope.optsGrid.data.length > 0) {
          /*------------------------------------------------*/
          /* Compile all inventory option objects to create */
          /* the list of implemented item master options    */
          /*------------------------------------------------*/
          var options = [];
          resp.data.forEach(function (ip) {
            options = options.concat(ip.options);
          });

          mInventoryColumn.setMasterOptions(
            Tools.mapUniqueObjects(options, 'masterOptionID', [
              { masterOptionID: 'id' },
              { masterOptionName: 'name' }
            ])
          );
        } else $scope.invItem =

        /*-----------------------------------------------*/
        /* There is only the base product option which   */
        /* will be used to set up the single item model. */
        /*-----------------------------------------------*/
          new DGProductPurchase(baseProduct, true, mProduct);

        BusyScreen.setBusy(false);
      });
    };

    /*****************************************************************************
     * add */
    /**
     * Handler for the 'Add New Item' button. Upon valid item(s), dismiss the dialog
     * with an array of DGProductPurchase items.
     *****************************************************************************/
    $scope.add = function () {
      /*---------------------------------------------------------------*/
      /* Check for valid data by seeing if the add button is available */
      /*---------------------------------------------------------------*/
      if ($scope.disableAddButton()) return;

      /*------------------------------------------*/
      /* Array of items to resolve the modal with */
      /*------------------------------------------*/
      var items = [];

      /*----------------*/
      /* Single Product */
      /*----------------*/
      if ($scope.showDetails()) items.push($scope.invItem);
      /*------------------------------------*/
      /* Otherwise add options with a total */
      /*------------------------------------*/ else
        $scope.optsGrid.data.forEach(function (dgItem) {
          if (dgItem.total > 0) items.push(dgItem);
        });

      $uibModalInstance.close(items);
    };

    /*****************************************************************************
     * disableAddButton */
    /**
     * Returns true if the 'Add New Item' button should be disabled.
     * If the user is entering values for a single inventory item and all inputs are
     * valid, returns false.
     * If entering details for a product with multiple options, returns false when
     * there's a complete row with cost and quantity.
     *
     * @return         Boolean indicating if the button should be disabled
     *****************************************************************************/
    $scope.disableAddButton = function () {
      /*--------------------------------------*/
      /* Disable when adding details for a    */
      /* single item if there is a zero total */
      /*--------------------------------------*/
      if ($scope.showDetails()) return $scope.invItem.total == 0;
      /*------------------------------------------*/
      /* Disable when adding details for multiple */
      /* items and there are no non-zero totals.  */
      /*------------------------------------------*/ else if (
        $scope.showOptions()
      )
        return !$scope.optsGrid.data.some(function (dgItem) {
          return dgItem.total > 0;
        });
      else return true;
    };

    /*****************************************************************************
     * showDetails */
    /**
     * Returns an indication if an individual product is to be managed.
     *
     * @return Boolean
     *****************************************************************************/
    $scope.showDetails = function () {
      return !!$scope.invItem;
    };

    /*****************************************************************************
     * showOptions */
    /**
     * Returns true if the there are multiple inventory product options to manage.
     *
     * @return Boolean
     *****************************************************************************/
    $scope.showOptions = function () {
      return $scope.optsGrid.data.length > 0;
    };

    /*-------------------*/
    /* Initialize Values */
    /*-------------------*/
    $scope.categoryID(0);
  }

  /***************************************************************************
   * show */
  /**
   * Show the dialog.
   *
   * @param  products  Available inventory products
   * @return           Dialog promise object
   ***************************************************************************/
  this.show = function (products) {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      controller: AddInventoryItemController,
      resolve: {
        products: function () {
          return products;
        }
      },
      size: 'md',
      template: addInventoryItemTemplate
    }).result;
  };
}
